import {Application} from '@app/views/admin/application-settings/models/application.model';
import {ProblemType} from '@app/views/dashboard/dashboard.model';
import {TemplateRef} from '@angular/core';

export enum BANNER_NOTIFICATION_TYPE {
    APP_CONFIGURATION_NOT_VALID = 'APP_CONFIGURATION_NOT_VALID',
    APPLICATION_PRIVACY_POLICY_REJECTED = 'APPLICATION_PRIVACY_POLICY_REJECTED',
    APPLICATION_PRIVACY_POLICY_UPDATED = 'APPLICATION_PRIVACY_POLICY_UPDATED',
    APP_EXPIRED = 'APP_EXPIRED',
    APP_EXPIRATION_LESS_THEN_10_DAY = 'APP_EXPIRATION_LESS_THEN_10_DAY',
    APP_EXPIRATION_LESS_THEN_30_DAY = 'APP_EXPIRATION_LESS_THEN_30_DAY',
    APP_SUSPENDED = 'APP_SUSPENDED',
    APP_HAS_PENDING_REQUESTS = 'APP_HAS_PENDING_REQUESTS',
    APP_PENDING_APPROVAL = 'APP_PENDING_APPROVAL',
    DATA_ACCESS_ISSUE = 'DATA_ACCESS_ISSUE',
    DATA_ACCESS_PROGRESS = 'DATA_ACCESS_PROGRESS',
    APPLICATION_WITHOUT_SCHEDULE = 'APPLICATION_WITHOUT_SCHEDULE',
    DATA_SOURCE_CONFIGURATION_NOT_COMPLETE = 'DATA_SOURCE_CONFIGURATION_NOT_COMPLETE',
    DATA_SOURCE_CONFIGURATION_NOT_VALID = 'DATA_SOURCE_CONFIGURATION_NOT_VALID',
    DATA_SOURCE_PRIVACY_POLICY_REJECTED = 'DATA_SOURCE_PRIVACY_POLICY_REJECTED',
    DATA_SOURCE_EXPIRED = 'DATA_SOURCE_EXPIRED',
    DATA_SOURCE_EXPIRATION_LESS_THEN_30_DAY = 'DATA_SOURCE_EXPIRATION_LESS_THEN_30_DAY',
    ORG_MAPPING_NOT_CONFIGURED = 'ORG_MAPPING_NOT_CONFIGURED',
    ORG_MAPPING_ISSUE = 'ORG_MAPPING_ISSUE',
    MAPPING_RULES_NOT_CONFIGURED = 'MAPPING_RULES_NOT_CONFIGURED',
    SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD = 'SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD',
    DISABLED_DELETION_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD = 'DISABLED_DELETION_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD',
    SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT = 'SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT',
    SIGNIFICANT_CHANGES_DETECTED_IN_OTHER = 'SIGNIFICANT_CHANGES_DETECTED_IN_OTHER',
    SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS = 'SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS',
    CHANGES_PENDING_APPROVAL_BY_SYSADMIN = 'CHANGES_PENDING_APPROVAL_BY_SYSADMIN',
    CHANGES_PENDING_APPROVAL = 'CHANGES_PENDING_APPROVAL',
    PREVIEW_MODE = 'PREVIEW_MODE',
    CSV_UPLOAD_TEMPORARY_DISABLED = 'CSV_UPLOAD_TEMPORARY_DISABLED',
    RUN_SYNC_TEMPORARY_DISABLED = 'RUN_SYNC_TEMPORARY_DISABLED',
    SFTP_EXPORT_FILES_DOWNLOAD_READY = 'SFTP_EXPORT_FILES_DOWNLOAD_READY',
    DATABROWSING_CONTEXT_NOTIFICATION = 'DATABROWSING_CONTEXT_NOTIFICATION',
    WARNING_SYNC = 'WARNING_SYNC',
    FAILED_SYNC = 'FAILED_SYNC',
    SYNCHRONIZATION = 'SYNCHRONIZATION',
    SCHOOL_PASSPORT_LOGIN_REQUIRED = 'SCHOOL_PASSPORT_LOGIN_REQUIRED',

    DISTRICT_CONFIGURATION_NOT_VALID = 'DISTRICT_CONFIGURATION_NOT_VALID',
    DISTRICT_EXPIRED = 'DISTRICT_EXPIRED',
    DISTRICT_EXPIRATION_LESS_THEN_10_DAY = 'DISTRICT_EXPIRATION_LESS_THEN_10_DAY',
    DISTRICT_EXPIRATION_LESS_THEN_30_DAY = 'DISTRICT_EXPIRATION_LESS_THEN_30_DAY',
    PRIVACY_POLICY_REJECTED = 'PRIVACY_POLICY_REJECTED',
    NEW_DATA_AVAILABLE = 'NEW_DATA_AVAILABLE',
    SPECIAL_OFFER_ACTIVATION = 'SPECIAL_OFFER_ACTIVATION',

    CUSTOM_MESSAGE_ERROR_NOTIFICATION = 'CUSTOM_MESSAGE_ERROR_NOTIFICATION',
}

export interface IBannerNotification {
    type: BANNER_NOTIFICATION_TYPE;
    application: Application;
    template?: TemplateRef<any>;
    message?: string;
}

export const IssueToNotificationTypeMap = new Map([
    [ProblemType.APPLICATION_WITHOUT_SCHEDULE, BANNER_NOTIFICATION_TYPE.APPLICATION_WITHOUT_SCHEDULE],
    [ProblemType.EXPIRED_APPLICATION, BANNER_NOTIFICATION_TYPE.APP_EXPIRED],
    [ProblemType.EXPIRE_SOON_INTEGRATION, null],
    [ProblemType.PENDING_APPLICATION, BANNER_NOTIFICATION_TYPE.APP_PENDING_APPROVAL],
    [ProblemType.SUSPENDED_APPLICATION, BANNER_NOTIFICATION_TYPE.APP_SUSPENDED],
    [ProblemType.REJECTED_PP_APPLICATION, BANNER_NOTIFICATION_TYPE.APPLICATION_PRIVACY_POLICY_REJECTED],
    [ProblemType.CONNECTION, BANNER_NOTIFICATION_TYPE.APP_CONFIGURATION_NOT_VALID],
    [ProblemType.SCHOOL_MAPPING_WITH_VANISHED_SCHOOL, BANNER_NOTIFICATION_TYPE.ORG_MAPPING_ISSUE],
    [ProblemType.SCHOOL_MAPPING, BANNER_NOTIFICATION_TYPE.ORG_MAPPING_ISSUE],
    [ProblemType.DATA_ACCESS, BANNER_NOTIFICATION_TYPE.DATA_ACCESS_ISSUE],
    [ProblemType.CHANGES_PENDING_APPROVAL_BY_SYSADMIN, BANNER_NOTIFICATION_TYPE.CHANGES_PENDING_APPROVAL_BY_SYSADMIN],
    [ProblemType.CHANGES_PENDING_APPROVAL, BANNER_NOTIFICATION_TYPE.CHANGES_PENDING_APPROVAL],
    [ProblemType.WARN, BANNER_NOTIFICATION_TYPE.WARNING_SYNC],
    [ProblemType.FAILED_SYNC, BANNER_NOTIFICATION_TYPE.FAILED_SYNC],
    [ProblemType.SYNCHRONIZATION, BANNER_NOTIFICATION_TYPE.SYNCHRONIZATION],
    [ProblemType.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD, BANNER_NOTIFICATION_TYPE.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD],
    [ProblemType.SPECIAL_OFFER_ACTIVATION, BANNER_NOTIFICATION_TYPE.SPECIAL_OFFER_ACTIVATION],
    [ProblemType.PREVIEW_MODE, BANNER_NOTIFICATION_TYPE.PREVIEW_MODE],
]);

export const BANNER_NOTIFICATION_PRIORITY = [
    // Error messages
    BANNER_NOTIFICATION_TYPE.APP_CONFIGURATION_NOT_VALID,
    BANNER_NOTIFICATION_TYPE.DATA_SOURCE_CONFIGURATION_NOT_COMPLETE,
    BANNER_NOTIFICATION_TYPE.DATA_SOURCE_CONFIGURATION_NOT_VALID,
    BANNER_NOTIFICATION_TYPE.DATA_ACCESS_ISSUE,
    BANNER_NOTIFICATION_TYPE.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT,
    BANNER_NOTIFICATION_TYPE.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS,
    BANNER_NOTIFICATION_TYPE.CHANGES_PENDING_APPROVAL_BY_SYSADMIN,
    BANNER_NOTIFICATION_TYPE.CHANGES_PENDING_APPROVAL,
    BANNER_NOTIFICATION_TYPE.APP_EXPIRED,
    BANNER_NOTIFICATION_TYPE.APPLICATION_PRIVACY_POLICY_REJECTED,
    BANNER_NOTIFICATION_TYPE.DATA_SOURCE_PRIVACY_POLICY_REJECTED,
    BANNER_NOTIFICATION_TYPE.PRIVACY_POLICY_REJECTED,
    BANNER_NOTIFICATION_TYPE.DISTRICT_CONFIGURATION_NOT_VALID,
    BANNER_NOTIFICATION_TYPE.DISTRICT_EXPIRED,
    BANNER_NOTIFICATION_TYPE.FAILED_SYNC,

    // Warning messages
    BANNER_NOTIFICATION_TYPE.SYNCHRONIZATION,
    BANNER_NOTIFICATION_TYPE.WARNING_SYNC,
    BANNER_NOTIFICATION_TYPE.APP_SUSPENDED,
    BANNER_NOTIFICATION_TYPE.APP_EXPIRATION_LESS_THEN_30_DAY,
    BANNER_NOTIFICATION_TYPE.DISTRICT_EXPIRATION_LESS_THEN_10_DAY,
    BANNER_NOTIFICATION_TYPE.ORG_MAPPING_NOT_CONFIGURED,
    BANNER_NOTIFICATION_TYPE.ORG_MAPPING_ISSUE,
    BANNER_NOTIFICATION_TYPE.MAPPING_RULES_NOT_CONFIGURED,
    BANNER_NOTIFICATION_TYPE.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
    BANNER_NOTIFICATION_TYPE.DISABLED_DELETION_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
    BANNER_NOTIFICATION_TYPE.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER,
    BANNER_NOTIFICATION_TYPE.APP_PENDING_APPROVAL,

    // Info messages
    BANNER_NOTIFICATION_TYPE.CSV_UPLOAD_TEMPORARY_DISABLED,
    BANNER_NOTIFICATION_TYPE.RUN_SYNC_TEMPORARY_DISABLED,
    BANNER_NOTIFICATION_TYPE.DATA_ACCESS_PROGRESS,
    BANNER_NOTIFICATION_TYPE.SFTP_EXPORT_FILES_DOWNLOAD_READY,
    BANNER_NOTIFICATION_TYPE.APPLICATION_PRIVACY_POLICY_UPDATED,
    BANNER_NOTIFICATION_TYPE.PREVIEW_MODE,
    BANNER_NOTIFICATION_TYPE.APP_EXPIRATION_LESS_THEN_30_DAY,
    BANNER_NOTIFICATION_TYPE.DISTRICT_EXPIRATION_LESS_THEN_30_DAY,
    BANNER_NOTIFICATION_TYPE.DATA_SOURCE_EXPIRED,
    BANNER_NOTIFICATION_TYPE.DATA_SOURCE_EXPIRATION_LESS_THEN_30_DAY,
    BANNER_NOTIFICATION_TYPE.APPLICATION_WITHOUT_SCHEDULE,
    BANNER_NOTIFICATION_TYPE.NEW_DATA_AVAILABLE,
    BANNER_NOTIFICATION_TYPE.SPECIAL_OFFER_ACTIVATION,
];

export enum BANNER_EVENT_TYPE {
    EDIT_EXPIRATION_DATE = 'EDIT_EXPIRATION_DATE',
    OPEN_PRIVACY_POLICY = 'OPEN_PRIVACY_POLICY',
    OPEN_DATA_ACCESS_ISSUE_DETAILS = 'OPEN_DATA_ACCESS_ISSUE_DETAILS',
    APPLY_SIGNIFICANT_CHANGES = 'APPLY_SIGNIFICANT_CHANGES',
    APPLY_SIGNIFICANT_CHANGES_IN_ACCESS = 'APPLY_SIGNIFICANT_CHANGES_IN_ACCESS',
    OPEN_SIGNIFICANT_CHANGES_DETAILS = 'OPEN_SIGNIFICANT_CHANGES_DETAILS',
    DISABLE_SCHOOL_MAPPING_ISSUE = 'DISABLE_SCHOOL_MAPPING_ISSUE',
    DISABLE_FAILED_SYNC_ISSUE = 'DISABLE_FAILED_SYNC_ISSUE',
    DISABLE_SYNCHRONIZATION_ISSUE = 'DISABLE_SYNCHRONIZATION_ISSUE',
    DISABLE_WARNING_SYNC_ISSUE = 'DISABLE_WARNING_SYNC_ISSUE',
    DISABLE_BROKEN_CONNECTION_ISSUE = 'DISABLE_BROKEN_CONNECTION_ISSUE',
    RUN_DATA_ACCESS_CHECKING_PROCESS = 'RUN_DATA_ACCESS_CHECKING_PROCESS',
    DOWNLOAD_SFTP_EXPORT_FILES = 'DOWNLOAD_SFTP_EXPORT_FILES',
    SEND_SPECIAL_OFFER_ACTIVATION_EMAIL = 'SEND_SPECIAL_OFFER_ACTIVATION_EMAIL',
}

export interface IBannerUserEvent {
    eventType: BANNER_EVENT_TYPE;
    payload?: any;
}
